module.exports = __webpack_public_path__ + "static/img/544.0494d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/544.png
// module id = 393
// module chunks = 12 14